<script setup lang="ts">
  defineOptions({
    name: 'll-divider',
  });
</script>

<template>
  <div class="flex items-center text-center uppercase" :class="$style.separator" role="separator">
    <slot></slot>
  </div>
</template>

<style module>
  @reference "../../../styles/main.css";

  .separator::before,
  .separator::after {
    border-bottom: 1px solid var(--color-ice-200);
    content: '';
    flex: 1;
  }

  .separator:not(:empty)::before {
    margin-right: --spacing(3);
  }

  .separator:not(:empty)::after {
    margin-left: --spacing(3);
  }
</style>
